import tw from "twin.macro";
export const PrimaryButton = tw.button` text-5xl font-bold rounded text-gray-100  focus:shadow-outline focus:outline-none transition duration-300`;
